import {
  MenuItemCreateDeep,
  MenuItemUpdateDeepInBatch,
  MenuOptionGroupCreateDeep,
  MenuOptionGroupUpdateDeepInBatch,
} from "client/jspPlatformExperiment";
import {
  DisplayMenuItem,
  DisplayMenuSection,
} from "models/menu/menuContentsReducer";
import { isDisplayMenuItem } from "models/menu/menu";
import { toOverrideCreate } from "models/menu/menuItemTagOverride";

export function getMenuOptionGroupFromDisplay(
  displayOptionGroup: DisplayMenuSection,
  forceCreate: boolean = false,
): MenuOptionGroupCreateDeep | MenuOptionGroupUpdateDeepInBatch {
  const menuOptionGroupData = {
    ...displayOptionGroup,
    // Each row is an explicitly-chosen food (main or variant), so options are
    // serialized in the user's chosen order without reordering variants.
    options: Object.values(displayOptionGroup.options).map((option) => {
      if (isDisplayMenuItem(option)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return getMenuItemFromDisplay(option, forceCreate);
      }
      return getMenuOptionGroupFromDisplay(option, forceCreate);
    }),
  };

  // Has option group ID so it's updating
  if (displayOptionGroup.id && !forceCreate) {
    return menuOptionGroupData as MenuOptionGroupUpdateDeepInBatch;
  }
  // NO option group ID so it's creating
  return menuOptionGroupData as MenuOptionGroupCreateDeep;
}

export function getMenuItemFromDisplay(
  menuItemData: DisplayMenuItem,
  forceCreate: boolean = false,
): MenuItemCreateDeep | MenuItemUpdateDeepInBatch {
  const menuItem = {
    ...menuItemData,
    side_option_groups: Object.values(
      menuItemData.side_option_groups ?? {},
    ).map((sideOptGroup) => getMenuOptionGroupFromDisplay(sideOptGroup)),
    food_tag_overrides: (menuItemData.food_tag_overrides ?? []).map(
      toOverrideCreate,
    ),
  };

  // Has option group ID so it's updating
  if (menuItemData.id && !forceCreate) {
    return menuItem as MenuItemUpdateDeepInBatch;
  }
  // NO option group ID so it's creating
  return menuItem as MenuItemCreateDeep;
}
